module.exports = __webpack_public_path__ + "img/new years shrine visit i.512cdf97.png";